import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as AuthActions from "../actionTypes/authActionTypes";
import * as AuthActionCreators from "../actionCreators/authActionCreators"
import { authenticate } from "../services/APIservice";
import { getTransactionIdFromURL, saveKeyToLocalStorage } from "../../constants/utils";
import { ARGO_SUCCESS, AUTH_KEY } from "../../constants/constants";


function* onIbAuthentication({ request }: AuthActions.GetIBAuthenticationAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(AuthActionCreators.ibAuthenticateRequest())
    const { data } = yield call(authenticate, request);
    if (data.code === ARGO_SUCCESS) {
      const { token, partnerId, partnerName, resumeJourneyEligibility, originalTxnId, customerId } = data.data;
      saveKeyToLocalStorage(AUTH_KEY(txnId), token)
      let res = {
        authResponse: true,
        partnerId: partnerId,
        partnerName: partnerName,
        resumeJourneyEligibility: resumeJourneyEligibility,
        originalTxnId: originalTxnId,
        customerId: customerId,
      }
      yield put(AuthActionCreators.ibAuthenticateSuccess(res));
    } else {
      throw data
    }
  } catch (error) {
    if(error.status){
    yield put(AuthActionCreators.ibAuthenticateFailure(error))
  }
  else {
    yield put(AuthActionCreators.ibAuthenticateError())
  }
  }
}

function* watchOnIbAuthentication() {
  yield takeEvery(AuthActions.GET_IB_AUTHENTICATION, onIbAuthentication)
}

export default function* AuthSaga() {
  yield all([fork(watchOnIbAuthentication)])
}